import { Loader, Form } from '@patrianna/core-components'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import useJumioCardVerification from '@patrianna-payments/shared-store/verifications/hooks/card-verification/useJumioCardVerification'
import { cardVerificationsRequest } from '@patrianna-payments/shared-store/verifications/store/actions'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

import content from 'prismic-translates/page-verifications.json'
import Button from 'src/components/Button'
import RichText from 'src/components/RichText'
import { serviceFraudDependencies } from 'src/services'
import { useAppDispatch } from 'src/store/hooks'

import CheckboxIcon from './components/CheckboxIcon'
import FormPaymentMethodSelectFields from './components/FormPaymentMethodSelectFields'
import useSelectPaymentMethodValues from './hooks/useSelectPaymentMethodValues'
import classes from './styles.module.scss'
import { getVerificationStatusComponent } from './utils'

import type { PaymentMethodType } from '@patrianna/shared-patrianna-types/store/PaymentsFlowModule'

export type FormProps = {
  selectedPaymentMethod: PaymentMethodType | ''
  selectedCardId: string
}

const t = getTranslationFromJson([content])

const defaultValues: FormProps = {
  selectedPaymentMethod: '',
  selectedCardId: '',
}

export function PaymentMethodVerification() {
  const { getCardById } = useSelectPaymentMethodValues()
  const { startIframeJumioVerificationProcess, loading } = useJumioCardVerification({
    fraud: serviceFraudDependencies.fraud,
  })
  const dispatch = useAppDispatch()
  const methods = useForm<FormProps>({ mode: 'onTouched', defaultValues })

  const handleSubmit = (values: FormProps) => {
    const selectedCard = getCardById(values.selectedCardId)
    const isRequiredVerification = selectedCard?.status === 'require_verification'
    if (isRequiredVerification) {
      startIframeJumioVerificationProcess(selectedCard?.fingerprint)
    }
  }

  const selectedCardIdWatch = methods.watch('selectedCardId')

  useEffect(() => {
    dispatch(cardVerificationsRequest())
  }, [])

  return (
    <Form methods={methods} onSubmit={handleSubmit} className={classes.root}>
      <p className={classes.cardVerificationAttention}>{t('card_title')}</p>
      {loading ? <Loader /> : <FormPaymentMethodSelectFields />}
      <RichText
        field={t('rules_list')}
        components={{
          list: ({ children }) => <ul className={classes.rules}>{children}</ul>,
          listItem: ({ children }) => (
            <li>
              <CheckboxIcon />
              {children}
            </li>
          ),
        }}
      />
      {!loading && getVerificationStatusComponent(getCardById(selectedCardIdWatch)?.status, t)}

      <Button
        className={classes.submitButton}
        disabled={getCardById(selectedCardIdWatch)?.status !== 'require_verification'}
      >
        {t('submit')}
      </Button>
      <RichText
        field={t('trusted_partners')}
        components={{
          paragraph: ({ children }) => <p className={classes.trustedPartners}>{children}</p>,
          strong: ({ children }) => <span>{children}</span>,
        }}
      />
    </Form>
  )
}
//
